import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import NamedLink from '../NamedLink/NamedLink';
import { mergeFromIntoIntent } from '../../util/postAuthIntent';

/**
 * Link to login/signup that preserves the current page for post-auth redirect.
 */
const AuthIntentLink = props => {
  const { routeName, className, children, params } = props;
  const location = useLocation();
  const returnPath = `${location.pathname}${location.search}${location.hash}`;

  const handleClick = () => {
    mergeFromIntoIntent(returnPath);
  };

  return (
    <NamedLink
      name={routeName}
      params={params}
      className={className}
      to={{ state: { from: returnPath } }}
      onClick={handleClick}
    >
      {children}
    </NamedLink>
  );
};

AuthIntentLink.propTypes = {
  routeName: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  params: PropTypes.object,
};

AuthIntentLink.defaultProps = {
  className: null,
  children: null,
  params: {},
};

export default AuthIntentLink;
